import { createFileRoute } from "@tanstack/react-router";

import { NotificationSchedulesPage } from "@/features/zdalny-dostep/notification-schedules-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/harmonogramy-powiadomien")({
	component: NotificationSchedulesPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.zdalny-dostep.harmonogramy",
			location.pathname,
		);
	},
});
